import Input from '@mui/material/Input';
import { useState } from 'react';

const FileInput=({onChange})=>{  
    const[file,setFile] =useState();

    function handleResumeChange(event) {
        const selectedFile = event.target.files[0];
        setFile(selectedFile);
        console.log(selectedFile);
       onChange(event);
  }
    return(
        <>
        <Input
        fullWidth
        hidden
        onChange={handleResumeChange}
        type={'file'}
        id='browse'
        className='fileInput'
        inputProps={{accept:"application/pdf,application/docx"}}
        multiple={false}
        />
        <label htmlFor='browse' className='upload-label'>
            Upload Resume
        </label>
        {file && <li className='uploaded-file'>{file?.name}</li>}
        </>

    )
}
export default FileInput;